import type { TOptions } from 'i18next';

export type TranslationKey = readonly [nsKey: `${string}:${string}`, defaultValue: string];

export type BaseTranslateFn = (key: string, options?: TOptions) => string;

export type TupleTFunction = (key: TranslationKey, options?: TOptions) => string;

export function translate(
  baseT: BaseTranslateFn,
  key: TranslationKey,
  options?: TOptions,
): string {
  const [nsKey, defaultValue] = key;
  return baseT(nsKey, { ...options, defaultValue });
}
